// Perfis e áreas. Protótipo: PERMS, PRESETS, can e permsLabel (1955–2147).
// A checagem que vale é a do servidor; o front só usa isto para montar o menu.

export const AREAS = [
  ['vistoriar', 'Fazer vistorias (formulário)'],
  ['dash', 'Painel de vistorias'],
  ['hist', 'Vistorias analisadas'],
  ['reports', 'Relatórios e histórico'],
  ['obras', 'Obras e alojamentos (cadastro)'],
  ['gestao', 'Gestão de alojamentos (contratos, gastos e dashboard)'],
  ['checklist', 'Checklist de itens'],
  ['aprovar', 'Aprovar, reprovar e excluir vistorias'],
  ['notificar', 'Enviar notificações e cobranças por e-mail'],
  ['config', 'Ajustes gerais'],
] as const;

export type Area = (typeof AREAS)[number][0];
export const CODIGOS_AREA: readonly Area[] = AREAS.map((a) => a[0]);

/** Atalhos da tela de usuários. "Vistoriador" é novo (decisão 7.1). */
export const PRESETS: Record<'vistoriador' | 'vistorias' | 'total', readonly Area[]> = {
  vistoriador: ['vistoriar'],
  vistorias: ['dash', 'hist'],
  total: ['dash', 'hist', 'reports', 'obras', 'gestao', 'checklist', 'aprovar', 'notificar'],
};

export interface Acesso {
  perfil: 'admin' | 'usuario';
  permissoes: readonly string[];
}

export function pode(u: Acesso | null | undefined, area: Area | 'usuarios'): boolean {
  if (!u) return false;
  if (u.perfil === 'admin') return true;
  if (area === 'usuarios') return false;
  return u.permissoes.includes(area);
}

function mesmoConjunto(a: readonly string[], b: readonly string[]): boolean {
  const x = [...new Set(a)].sort().join(',');
  const y = [...new Set(b)].sort().join(',');
  return x === y;
}

/** Rótulo do perfil no cabeçalho e nos cartões de usuário. */
export function rotuloDoAcesso(u: Acesso): string {
  if (u.perfil === 'admin') return 'Administrador';
  if (!u.permissoes.length) return 'Sem acesso';
  if (mesmoConjunto(u.permissoes, PRESETS.vistoriador)) return 'Vistoriador';
  if (mesmoConjunto(u.permissoes, PRESETS.vistorias)) return 'Somente vistorias';
  if (mesmoConjunto(u.permissoes, PRESETS.total)) return 'Acesso total';
  return 'Personalizado';
}

/** Áreas da gestão na ordem do menu, para cair na primeira liberada. */
export const ORDEM_GESTAO: readonly (Area | 'usuarios')[] = ['dash', 'hist', 'reports', 'obras', 'gestao', 'checklist', 'config'];

export function primeiraAreaDaGestao(u: Acesso): Area | 'usuarios' | null {
  return ORDEM_GESTAO.find((a) => pode(u, a)) ?? null;
}
